
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

// Suas chaves do Firebase (Configuração oficial do projeto cromoterapia-aplicada)
export const firebaseConfig = {
  apiKey: "AIzaSyC950JrTE94vBecVYPf03oOK-Y3ko4P4_Q",
  authDomain: "cromoterapia-aplicada.firebaseapp.com",
  projectId: "cromoterapia-aplicada",
  storageBucket: "cromoterapia-aplicada.firebasestorage.app",
  messagingSenderId: "863885576624",
  appId: "1:863885576624:web:27e454f53e041f7af76e75",
  measurementId: "G-TEFWT232HV"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Inicializa os serviços
const auth = getAuth(app);
const db = getFirestore(app);

// Configura persistência local (o usuário continua logado mesmo se fechar a aba)
setPersistence(auth, browserLocalPersistence)
  .catch((error) => console.error("Erro ao configurar persistência de login:", error));

// Habilita persistência de dados offline
try {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn("Persistência offline falhou: Múltiplas abas abertas.");
    } else if (err.code === 'unimplemented') {
      console.warn("O navegador não suporta persistência de dados offline.");
    }
  });
} catch (e) {
  console.error("Erro ao inicializar Firestore Offline:", e);
}

export { app, auth, db };
